import React from "react";

import moment from "moment";
import "moment/locale/es";
import { Link } from "react-router-dom";
import {
  RECEPTIONIST_ORDERS_PATH,
  USER_ORDERS_PATH,
} from "../../constants/paths";

const OrderPreview = ({ client, dateCreated, cost, status, id, profile }) => {
  const total = typeof cost === "string" ? parseFloat(cost) : cost;
  const DotComponent = ({ status }) => {
    let color;

    switch (status) {
      case "solicitada":
        color = "bg-gray-500";
        break;

      case "completada":
        color = "bg-green-500";
        break;

      case "aceptada":
        color = "bg-yellow-500";
        break;

      case "en curso":
        color = "bg-orange-500";
        break;

      case "cancelada":
        color = "bg-red-500";
        break;

      default:
        break;
    }
    return (
      <div className={`rounded-full w-2 h-2 ${color} inline-block mr-1`}></div>
    );
  };
  return (
    <Link
      to={
        !profile?.isReceptionist
          ? `${USER_ORDERS_PATH}/${id}`
          : `${RECEPTIONIST_ORDERS_PATH}/${id}`
      }
      className="bg-white rounded-sm border border-gray-300 px-3 py-2 relative flex items-start mb-2"
    >
      <div className="relative w-full">
        <h5 className="text-gray-700 font-bold flex items-center">{client}</h5>
        <p className="text-xs font-light text-gray-600">
          <span className="flex items-center">
            <DotComponent status={status}></DotComponent>
            <span className="capitalize mr-1">{status}</span>
            {" " + moment(dateCreated.toDate()).fromNow()}
          </span>
        </p>
      </div>
      <p className="w-auto flex items-baseline text-xl font-bold">
        <span className="text-sm mr-1 font-normal">$ </span>
        {total.toFixed(2)} <span className="text-xs ml-1 font-normal">MXN</span>
      </p>
    </Link>
  );
};

export default OrderPreview;
